export const displayCallBackCountdown = (minutes: number) => {
    const negativeCompensation = minutes < 0 ? 1 : 0;
    let hours = Math.abs(Math.floor(minutes / 60) + negativeCompensation);
    let mins = Math.abs(minutes % 60);

    let hoursString = hours.toString();
    let minsString = mins.toString();

    if (hours < 10) {
        hoursString = `0${hoursString}`;
    }

    if (mins < 10) {
        minsString = `0${minsString}`;
    }

    return `${minutes < 0 ? "-" : ""}${hoursString}:${minsString}`;
};
